import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'

import Styles from './index.scss'
import StylesJS from './styles.js'

const renderTitle = () => (
  <div>
    Alert
  </div>
)

const renderActions = props => (
  <div className={Styles['btn-container']}>
    <button
      className={Styles['btn-cancel']}
      onClick={props.onCloseModal(false)}
    >
      Cancel
    </button>
    <button
      className={Styles['btn-confirm']}
      onClick={props.onClickConfirm}
    >
      Confirm
    </button>
  </div>
)

const ModalDelete = props => (
  <Dialog
    title={renderTitle()}
    titleStyle={StylesJS.titleStyles}
    actions={renderActions(props)}
    actionsContainerStyle={StylesJS.actionsStyles}
    bodyStyle={StylesJS.bodyStyles}
    contentStyle={StylesJS.customContentStyles}
    open={props.isModalOpen}
    onRequestClose={props.onCloseModal(false)}
  >
    {props.children}
  </Dialog>
)

renderActions.defaultProps = {
  onCloseModal: () => { },
  onClickConfirm: () => { },
}

ModalDelete.defaultProps = {
  isModalOpen: false,
  onCloseModal: () => { },
  children: PropTypes.element,
}

renderActions.propTypes = {
  onCloseModal: PropTypes.func.isRequired,
  onClickConfirm: PropTypes.func.isRequired,
}

ModalDelete.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseModal: () => { },
  children: PropTypes.element,
}

export default ModalDelete
